import axios from "axios";

let APIKit = axios.create({
  // baseURL: "https://audacious-relay-recliner.ngrok-free.dev/api",
  // baseURL: "https://inv-api-qa.azurewebsites.net/api",
  // baseURL: "https://spark-admin.azurewebsites.net/api",
  baseURL: "https://spark-jobs.greenman.energy/api", //Dev build
});

APIKit.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    config.headers["ngrok-skip-browser-warning"] = "12321";
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
    console.log(error);
  },
);

APIKit.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If the error status is 401 and there is no originalRequest._retry flag,
    // it means the token has expired and we need to refresh it
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = await localStorage.getItem("refreshToken");
        const response = await APIKit.post("/users/refresh", { refreshToken });
        const { accessToken } = response.data.result;

        // Retry the original request with the new token
        originalRequest.headers.Authorization = accessToken;
        await setClientToken(accessToken);
        return APIKit(originalRequest);
      } catch (error) {
        // Handle refresh token error (e.g., refresh token is expired or invalid)
        console.error("Refresh token failed", error);

        // Clear tokens and redirect to login or handle the error as needed
        await localStorage.removeItem("token");
        await localStorage.removeItem("refreshToken");

        // Redirect to login page or show a login modal
        // Example: navigation.navigate('Login');
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  },
);

export const setClientToken = async (token) => {
  await localStorage.setItem("token", `${token}`);
};

export default APIKit;
